<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>point_of_sale</mat-icon></div>
          <mat-card-title>
            Caixa
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <form *ngIf="formulario && !carregando" [formGroup]="formulario" (ngSubmit)="submit()">
          <div class="row">
            <div class="col-1">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>ID</mat-label>
                <input formControlName="id" matInput readonly>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Nome</mat-label>
                <input formControlName="name" matInput placeholder="Digite seu nome" minlength="3"
                  maxlength="50" required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Saldo Pix</mat-label>
                <span matPrefix>R$ &nbsp;</span>
                <input matInput formControlName="pixBalance" mask="separator.2" thousandSeparator="."
                  placeholder="1.000,00" minlength="1" maxlength="6" required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Saldo Caixa</mat-label>
                <span matPrefix>R$ &nbsp;</span>
                <input matInput formControlName="caixaBalance"
                  currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Saldo Cartão</mat-label>
                <span matPrefix>R$ &nbsp;</span>
                <input matInput formControlName="cartaoBalance" mask="separator.2" thousandSeparator="."
                  placeholder="1.000,00" minlength="1" maxlength="6" required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Situação do caixa</mat-label>
                <mat-select formControlName="active" required>
                  <mat-option value="true">Ativo</mat-option>
                  <mat-option value="false">Inativo</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" (click)="limpar()" mat-stroked-button>
              <mat-icon>insert_drive_file</mat-icon> Limpar
            </button>
            <button [disabled]="!formulario.valid" mat-raised-button color="primary" type="submit">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </form>

        <div class="esp-top" *ngIf="formulario && !carregando">
          <div *ngIf="formulario.controls.name.errors && !formulario.controls.name.pristine"
            class="alert alert-warning" role="alert">
            Campo nome deve conter entre 3 e 50 caracteres!
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</main>
